import React from "react";
import { Container, Row, Col } from "react-bootstrap/";
import Linkedin from "../images/linkedin2.svg";
import GitHub from "../images/github.svg";
import Email from "../images/email.svg";
import "./Footer.css";
import Resume from "../Assets/Divyansh Goyal's Resume.pdf";

function Footer() {
  return (
    <footer className="footerSection" id="contactMe">
      <Container>
        <div className="glass-card footerCard p-4 p-md-5">
          <Row className="align-items-center g-4">
            <Col xs={12} lg={7} className="text-start">
              <h2 className="footerHeadline">Let's Connect &amp; Build Together</h2>
              <p className="footerSubtext">
                I am always open to discussing new opportunities or collaborating on innovative technical projects!
              </p>
              <div className="footerCTA">
                <a
                  href="mailto:divyansh.goyal2001@gmail.com"
                  className="btn-primary-custom"
                >
                  ✉️ Send an Email
                </a>
                <a
                  href={Resume}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-secondary-custom"
                >
                  📄 View Resume PDF
                </a>
              </div>
            </Col>

            <Col xs={12} lg={5}>
              <div className="socialGrid">
                <a
                  href="https://www.linkedin.com/in/divyansh-goyal2001/"
                  target="_blank"
                  rel="noreferrer"
                  className="socialTile"
                >
                  <img loading="lazy" src={Linkedin} alt="LinkedIn" className="socialIcon" />
                  <div className="socialLabel">LinkedIn</div>
                </a>

                <a
                  href="https://github.com/DG-20"
                  target="_blank"
                  rel="noreferrer"
                  className="socialTile"
                >
                  <img loading="lazy" src={GitHub} alt="GitHub" className="socialIcon" />
                  <div className="socialLabel">GitHub</div>
                </a>

                <a
                  href="mailto:divyansh.goyal2001@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="socialTile"
                >
                  <img loading="lazy" src={Email} alt="Email" className="socialIcon" />
                  <div className="socialLabel">Email</div>
                </a>
              </div>
            </Col>
          </Row>

          <hr className="footerDivider my-4" />

          <Row className="align-items-center">
            <Col xs={12} md={6} className="text-center text-md-start mb-2 mb-md-0">
              <span className="copyrightText">
                &copy; {new Date().getFullYear()} Divyansh Goyal. All rights reserved.
              </span>
            </Col>
            <Col xs={12} md={6} className="text-center text-md-end">
              <span className="builtWithText">
              </span>
            </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
